<template>
  <v-dialog v-model="open" :width="dialogWidth" persistent>
    <v-card>
      <v-card-title class="justify-center text-center">
        <v-icon v-if="icon" color="success" size="64" class="mb-4">check_circle</v-icon>
        <span class="confirm-dialog__title">{{ title }}</span>
      </v-card-title>

      <v-card-text class="text-center">
        <p v-if="message" class="confirm-dialog__message">{{ message }}</p>
        <p v-if="underText" class="confirm-dialog__undertext">{{ underText }}</p>
      </v-card-text>

      <v-card-actions class="justify-center pb-4">
        <v-btn v-if="showCancelButton" large :color="cancelColor" outlined @click.stop="onCancel()">
          {{ cancelText }}
        </v-btn>
        <v-btn large :color="confirmColor" :style="{ color: confirmFontColor }" @click.stop="onConfirm()">
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      open: false,
      title: '',
      message: '',
      underText: '',
      confirmText: 'Sair',
      cancelText: 'Cancelar',
      confirmColor: 'error',
      confirmFontColor: '#ffffff',
      cancelColor: 'grey',
      icon: false,
      showCancelButton: false
    }
  },
  computed: {
    dialogWidth() {
      return this.$vuetify?.breakpoint?.xs ? '80%' : '50%'
    }
  },
  methods: {
    onConfirm() {
      // Will be overridden by plugin
    },
    onCancel() {
      // Will be overridden by plugin
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-dialog__title {
  font-size: 1.5rem;
  font-weight: 500;
  width: 100%;
}

.confirm-dialog__message {
  font-size: 1rem;
  color: #666;
  margin-bottom: 8px;
}

.confirm-dialog__undertext {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0;
}

.v-card-title {
  flex-direction: column;
}

.v-card-actions {
  gap: 12px;
}
</style>
